<template>
  <div>
    <Title :pages="[{ icon: 'file-invoice', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <!-- Filtros -->
      <v-card v-if="list_access">
        <div class="row mb-2 mt-0">
          <div class="col-md-12">
            <div class="col-md-12 elevation-0" style="background: white">
              <div class="row pt-5">
                <div class="col-md-2 pt-0">
                  <v-menu ref="desde_menu" v-model="desde_menu" :close-on-content-click="false" :return-value.sync="desde_selected" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="desde_selected" label="Desde" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="desde_selected" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="desde_menu = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.desde_menu.save(desde_selected)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-2 pt-0">
                  <v-menu ref="hasta_menu" v-model="hasta_menu" :close-on-content-click="false" :return-value.sync="hasta_selected" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="hasta_selected" label="Hasta" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="hasta_selected" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="hasta_menu = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.hasta_menu.save(hasta_selected)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-3 pt-0">
                  <v-combobox v-model="emitter_selected" autocomplete="off" item-text="name" item-value="id" :items="emitters" label="Empresa" class="pt-0 mt-0"></v-combobox>
                </div>

                <div class="col-md-3 pt-0">
                  <v-combobox v-model="bank_selected" autocomplete="off" item-text="name" item-value="id" :items="banks" label="Banco" class="pt-0 mt-0" clearable></v-combobox>
                </div>
              </div>

              <!-- Los chips de Estados crecen con la seleccion: en la fila de arriba empujarian al
                   boton fuera de las 12 columnas. -->
              <div class="row pb-3">
                <!-- Lista cerrada: v-select y no v-combobox, que aceptaria texto libre que el
                     reporte no sabe filtrar. Vacio = todos los estados. -->
                <div class="col-md-4 pt-0">
                  <v-select v-model="states_selected" item-text="name" item-value="id" :items="states" label="Estados" class="pt-0 mt-0" multiple small-chips clearable></v-select>
                </div>

                <div class="col pt-0" style="display: flex; justify-content: end; align-items: center">
                  <v-btn color="info" @click="filter">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <!-- Matriz -->
      <v-card class="mt-3">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-btn color="blue-grey" small dark :loading="dialog_export" :disabled="loading || !data" @click="exportFile"> Exportar <font-awesome-icon class="ml-2" icon="download" /></v-btn>
        </v-card-title>

        <v-alert dense text type="info" class="mx-4 mb-0">
          La columna <b>Anterior</b> junta los cheques pendientes con fecha de pago previa al período: es la que forma el saldo de inicio del primer día.
        </v-alert>

        <v-alert v-if="sin_imputar" dense text type="warning" class="mx-4 mb-0">
          Hay {{ sin_imputar.cantidad }} cheque(s) Sin Imputar por {{ formatUtils.formatPrice(sin_imputar.monto) }} que no se muestran: al no tener cuenta asignada no se puede determinar a qué empresa
          corresponden.
        </v-alert>

        <v-progress-linear v-if="loading" indeterminate color="info"></v-progress-linear>

        <TablaCashFlowCheques :data="data" :loading="loading" :update_access="update_access" @accion="onAccion"></TablaCashFlowCheques>
      </v-card>

      <!-- El mismo modal del listado de Cheques: con formBtn vacio queda en modo solo lectura. -->
      <ModalCheque modal_title="Cheque" :formBtn="''" :dialog="dialog_cheque" :item="cheque_item" :service="checkService" @updateDialog="(value) => (dialog_cheque = value)" @loadList="() => {}" />

      <!-- Los mismos modales de accion del listado de Cheques. La accion cambia los saldos, asi
           que al confirmar se recalcula el reporte entero y no solo la fila. -->
      <ModalChangeState
        :show="dialog_change_state"
        :modal_title="title_change_state"
        :action="change_state_action"
        :cheques="cheques_seleccionados"
        @refresh="filter"
        @close="dialog_change_state = false"
      />

      <ModalRechazar :show="dialog_rechazar" :check="cheque_item" @refresh="filter" @close="dialog_rechazar = false" />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { emmiterService } from "@/libs/ws/emmiterService";
import { formatUtils } from "@/libs/utils/formatUtils";

import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import Title from "@/components/Title.vue";
import TablaCashFlowCheques from "./TablaCashFlowCheques.vue";
import ModalCheque from "@/views/Cheques/Modal.vue";
import ModalChangeState from "@/views/Cheques/ModalChangeState.vue";
import ModalRechazar from "@/views/Cheques/ModalRechazar.vue";
import { checkService } from "@/libs/ws/checkService";
import ChequesState from "@/constants/chequesStates";
import ChequesAcciones from "@/constants/chequesAcciones";

const MAX_MESES = 6;

export default {
  components: { Title, TablaCashFlowCheques, ModalCheque, ModalChangeState, ModalRechazar },
  mixins: [GenericMixin, RolMixin, ExportMixin],
  data() {
    return {
      formatUtils: formatUtils,
      checkService: checkService,
      page_title: "Cash Flow de Cheques",
      dialog_cheque: false,
      dialog_change_state: false,
      dialog_rechazar: false,
      change_state_action: "",
      title_change_state: "",
      cheque_item: null,
      data: null,
      desde_menu: false,
      hasta_menu: false,
      desde_selected: new Date().toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getTime() + 30 * 86400000).toISOString().slice(0, 10),
      emitter_selected: null,
      emitters: [],
      bank_selected: null,
      banks: [],
      // Los unicos estados que el reporte proyecta: el resto ya impacto en una cuenta de fondos.
      states: [
        { id: ChequesState.STATE_DEPOSITADO, name: "Depositado" },
        { id: ChequesState.STATE_EN_CARTERA, name: "En Cartera" },
        { id: ChequesState.STATE_UTILIZADO, name: "Utilizado" },
        { id: ChequesState.STATE_NEGOCIADO, name: "Negociado" },
      ],
      states_selected: [],
    };
  },
  computed: {
    // ModalChangeState trabaja sobre un lote; desde el reporte siempre es un cheque solo.
    cheques_seleccionados() {
      return this.cheque_item != null ? [this.cheque_item] : [];
    },
    // Solo se avisa si efectivamente quedo alguno afuera.
    sin_imputar() {
      if (this.data == null || !this.data.sin_imputar || this.data.sin_imputar.cantidad === 0) return null;
      return this.data.sin_imputar;
    },
  },
  mounted() {
    this.loadCombos();
  },
  methods: {
    loadCombos() {
      emmiterService.filter({ enabled: true }).then((response) => {
        this.emitters = response.result;
        // Con una sola empresa el filtro no aporta: se elige sola y se trae el reporte.
        if (this.emitters.length === 1) {
          this.emitter_selected = this.emitters[0];
          this.filter();
        }
      });
      generalService.filter({ enable: true }, Constant.SECTION_BANKS).then((response) => {
        this.banks = response.result;
      });
    },
    getFilterParams() {
      return {
        from: this.desde_selected,
        to: this.hasta_selected,
        emitter: this.emitter_selected != null ? this.emitter_selected.id : null,
        bank: this.bank_selected != null ? this.bank_selected.id : null,
        states: this.states_selected,
      };
    },
    // Tope del periodo en meses de calendario. El backend tambien lo valida.
    validFilters() {
      if (this.emitter_selected == null) {
        this.$toast.error("Seleccioná una empresa.", "Error");
        return false;
      }
      const desde = new Date(this.desde_selected);
      const hasta = new Date(this.hasta_selected);
      if (hasta < desde) {
        this.$toast.error("La fecha 'hasta' no puede ser anterior a la fecha 'desde'.", "Error");
        return false;
      }
      const limite = new Date(this.desde_selected);
      limite.setUTCMonth(limite.getUTCMonth() + MAX_MESES);
      if (hasta > limite) {
        this.$toast.error("El período no puede superar los " + MAX_MESES + " meses.", "Error");
        return false;
      }
      return true;
    },
    filter() {
      if (!this.validFilters()) return;
      this.loading = true;
      generalService
        .query(this.getFilterParams(), Constant.SECTION_REPORT_CASHFLOW_CHEQUES)
        .then((response) => {
          if (!response.status) {
            this.$toast.error(response.msg, "Error");
            return;
          }
          this.data = response.result;
        })
        .catch((e) => console.log(e))
        .finally(() => (this.loading = false));
    },
    // La matriz trae solo lo que necesita para proyectar; los modales quieren el cheque entero
    // (bank, importe, cobro o pago asociado), asi que se pide al abrirlos y no para las cientos de
    // filas del reporte.
    onAccion({ fila, action }) {
      checkService
        .filter({ id: fila.cheque_id })
        .then((response) => {
          if (!response.status || response.result.length === 0) {
            this.$toast.error("No se encontró el cheque.", "Error");
            return;
          }
          this.cheque_item = response.result[0];

          if (action === "ver") {
            this.dialog_cheque = true;
          } else if (action === "rechazar") {
            this.dialog_rechazar = true;
          } else {
            this.change_state_action = action;
            this.title_change_state = ChequesAcciones.nombreDe(action);
            this.dialog_change_state = true;
          }
        })
        .catch((e) => console.log(e));
    },
    exportFile() {
      if (!this.validFilters()) return;
      const param = this.getFilterParams();
      param.export = true;
      this.exportExcel(Constant.SECTION_REPORT_CASHFLOW_CHEQUES, param, "CashFlow-Cheques.xlsx");
    },
  },
};
</script>
